import { FC, ReactNode, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'next-i18next/pages'
import MenuClose from '@components/icons/MenuClose'
import s from './LoginPanel.module.scss'

interface Props {
    open: boolean
    onClose: () => void
    children: ReactNode
    labelledBy?: string
}

const LoginPanel: FC<Props> = ({ open, onClose, children, labelledBy }) => {
    const { t } = useTranslation('common')

    useEffect(() => {
        if (!open) return
        const previous = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        const onKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onClose()
        }
        window.addEventListener('keydown', onKey)
        return () => {
            document.body.style.overflow = previous
            window.removeEventListener('keydown', onKey)
        }
    }, [open, onClose])

    if (!open || typeof document === 'undefined') return null

    return createPortal(
        <div className={s.root}>
            <button
                type="button"
                className={s.overlay}
                aria-label={t('Close panel')}
                onClick={onClose}
            />
            <div
                className={s.panel}
                role="dialog"
                aria-modal="true"
                aria-labelledby={labelledBy}
            >
                <div className={s.header}>
                    <button
                        type="button"
                        className={s.close}
                        aria-label={t('Close panel')}
                        onClick={onClose}
                    >
                        <MenuClose />
                    </button>
                </div>
                <div className={s.body}>{children}</div>
            </div>
        </div>,
        document.body
    )
}

export default LoginPanel
